export default __webpack_public_path__ + "static/logo-bpress-stainless-steel-v2-cc2e2dbd6005974cde52e68f18b90b1f.svg";